import { useEventListener } from '@passkeys/hooks';
import { useMemo } from 'react';

import {
  createMessageHandler,
  WALLET_NAVIGATE_MESSAGE_TYPE,
} from '@/ui/utils/messages';
import { useNavigate } from '@/ui/utils/navigation';

function NavigateMessageHandler(): null {
  const navigate = useNavigate();

  const handleMessage = useMemo(
    () =>
      createMessageHandler(
        ({ data }) => data?.type === WALLET_NAVIGATE_MESSAGE_TYPE,
        ({ data }) => {
          navigate(data?.path);
        },
      ),
    [navigate],
  );

  useEventListener('message', handleMessage);

  return null;
}

export default NavigateMessageHandler;
